/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
    FileUploadDtoToJSONTyped,
} from './FileUploadDto';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { ImportMapping } from './ImportMapping';
import {
    ImportMappingFromJSON,
    ImportMappingFromJSONTyped,
    ImportMappingToJSON,
    ImportMappingToJSONTyped,
} from './ImportMapping';
import type { ImportStatus } from './ImportStatus';
import {
    ImportStatusFromJSON,
    ImportStatusFromJSONTyped,
    ImportStatusToJSON,
    ImportStatusToJSONTyped,
} from './ImportStatus';
import type { ImportConfigurationRequestDto } from './ImportConfigurationRequestDto';
import {
    ImportConfigurationRequestDtoFromJSON,
    ImportConfigurationRequestDtoFromJSONTyped,
    ImportConfigurationRequestDtoToJSON,
    ImportConfigurationRequestDtoToJSONTyped,
} from './ImportConfigurationRequestDto';

/**
 * 
 * @export
 * @interface ImportSessionDto
 */
export interface ImportSessionDto {
    /**
     * 
     * @type {string}
     * @memberof ImportSessionDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportSessionDto
     */
    userId?: string | null;
    /**
     * 
     * @type {ImportType}
     * @memberof ImportSessionDto
     */
    importType?: ImportType;
    /**
     * 
     * @type {ImportStatus}
     * @memberof ImportSessionDto
     */
    status?: ImportStatus;
    /**
     * 
     * @type {Array<FileUploadDto>}
     * @memberof ImportSessionDto
     */
    fileUploads?: Array<FileUploadDto> | null;
    /**
     * 
     * @type {ImportMapping}
     * @memberof ImportSessionDto
     */
    mapping?: ImportMapping;
    /**
     * 
     * @type {ImportConfigurationRequestDto}
     * @memberof ImportSessionDto
     */
    importConfiguration?: ImportConfigurationRequestDto;
    /**
     * 
     * @type {string}
     * @memberof ImportSessionDto
     */
    error?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ImportSessionDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportSessionDto
     */
    updatedAt?: Date;
}



/**
 * Check if a given object implements the ImportSessionDto interface.
 */
export function instanceOfImportSessionDto(value: object): value is ImportSessionDto {
    return true;
}

export function ImportSessionDtoFromJSON(json: any): ImportSessionDto {
    return ImportSessionDtoFromJSONTyped(json, false);
}

export function ImportSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'status': json['status'] == null ? undefined : ImportStatusFromJSON(json['status']),
        'fileUploads': json['fileUploads'] == null ? undefined : ((json['fileUploads'] as Array<any>).map(FileUploadDtoFromJSON)),
        'mapping': json['mapping'] == null ? undefined : ImportMappingFromJSON(json['mapping']),
        'importConfiguration': json['importConfiguration'] == null ? undefined : ImportConfigurationRequestDtoFromJSON(json['importConfiguration']),
        'error': json['error'] == null ? undefined : json['error'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ImportSessionDtoToJSON(json: any): ImportSessionDto {
    return ImportSessionDtoToJSONTyped(json, false);
}

export function ImportSessionDtoToJSONTyped(value?: ImportSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'importType': ImportTypeToJSON(value['importType']),
        'status': ImportStatusToJSON(value['status']),
        'fileUploads': value['fileUploads'] == null ? undefined : ((value['fileUploads'] as Array<any>).map(FileUploadDtoToJSON)),
        'mapping': ImportMappingToJSON(value['mapping']),
        'importConfiguration': ImportConfigurationRequestDtoToJSON(value['importConfiguration']),
        'error': value['error'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

